import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import { detachFromTree } from '../tree/utils';
import { type DragName, SEARCH_DRAG } from './constants';
import type { DraggedItemsAppState } from './types';

type SetItemsPayload = {
  name: DragName;
  draggedItems: SearchItemEntity[];
};

type SetTargetPayload = {
  name: DragName;
  id: string | undefined;
};

const initialState: DraggedItemsAppState = {
  items: {
    [SEARCH_DRAG]: [],
  },
  targets: {
    [SEARCH_DRAG]: undefined,
  },
};

export const draggedItemsSlice = createSlice({
  name: 'dragged_items',
  initialState,
  reducers: {
    setDraggedItems: (state, action: PayloadAction<SetItemsPayload>) => {
      state.items[action.payload.name] = detachFromTree(
        action.payload.draggedItems,
      );
    },
    setDropTargetId: (state, action: PayloadAction<SetTargetPayload>) => {
      state.targets[action.payload.name] = action.payload.id;
    },
  },
});

export const { setDraggedItems, setDropTargetId } = draggedItemsSlice.actions;

export const draggedItemsReducer = draggedItemsSlice.reducer;
